'use client';

import React from 'react';
import styled from 'styled-components';

import useTranslation from '../../translation/useTranslation';

function Empty() {
  const { t } = useTranslation();

  return (
    <EmptyBase>
      <span>
        {t('notification.empty.text')}
      </span>
    </EmptyBase>
  );
}

export default Empty;

export const EmptyBase = styled.div`
  color: var(--navbar-toggle-accent-color, #700);
  background: var(--navbar-toggle-accent-background, #FFF0F0);

  padding: 16px;
  line-height: 24px;
  border-radius: 8px;
`;
